import { useRouteMatch } from 'react-router-dom';

// TODO: remove this when we have a better way to detect native app
export function useIsNativeApp() {
    const match = useRouteMatch('/sso/*');
    return !!(match || new URLSearchParams(window.location.search).get('NATIVE_APP'));
}
